import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ButtonModule } from "primeng/button";
import { ButtonSeverity } from "../../utils/shared.models";

@Component({
  selector: "twx-button",
  imports: [ButtonModule],
  templateUrl: "./button.component.html",
  styleUrl: "./button.component.scss",
})
export class ButtonComponent {
  @Input() label!: string;
  @Input() disabled!: boolean;
  @Input() type = "button";
  @Input() icon!: string;
  @Input() severity: ButtonSeverity = "primary";
  @Input() styleClass = "";
  @Input() centeredText = false;
  @Input() rounded = false;
  @Output() buttonClicked = new EventEmitter<void>();
}
